{
  "retrievedAt": "2026-09-24T15:42:28.943178+00:00",
  "query": "Compare two fractions with the same numerator using fraction strips. Students compare 1/4 and 1/2 using the same-size whole, explain which is larger, and write 1/4 < 1/2.",
  "score": 0.8208898305892944,
  "standard": {
    "identifier": "2c7df3bd-8486-55aa-8d6a-d17899d9b399",
    "caseIdentifierURI": "https://teks-api.texasgateway.org/ims/case/v1p0/CFItems/11789916-bd5b-5277-806c-16a984a2d5cd",
    "caseIdentifierUUID": "11789916-bd5b-5277-806c-16a984a2d5cd",
    "statementCode": "111.5.b.3.H",
    "description": "compare two fractions having the same numerator or denominator in problems by reasoning about their sizes and justifying the conclusion using symbols, words, objects, and pictorial models.",
    "statementType": "Student Expectation",
    "normalizedStatementType": "Standard",
    "jurisdiction": "Texas",
    "academicSubject": "Mathematics",
    "gradeLevel": [
      "3"
    ],
    "inLanguage": "en-US",
    "dateModified": "2022-04-11",
    "notes": null,
    "author": "Texas Education Agency",
    "provider": "Learning Commons",
    "license": "https://creativecommons.org/licenses/by/4.0/",
    "attributionStatement": "Knowledge Graph is provided by Learning Commons under the CC BY-4.0 license. Texas Mathematics standards provided by Texas Education Agency available at http://ritter.tea.state.tx.us/rules/tac/chapter111.",
    "hasChildren": false
  }
}
